import * as __vanilla_filescope__ from '@vanilla-extract/css/fileScope';
__vanilla_filescope__.setFileScope("src/styles.css.ts", "@paypalcorp/pp-react-card");
import { style, globalStyle } from '@vanilla-extract/css';
import { tokens } from '@paypalcorp/pp-react-theme';
import { focusStyles } from '@paypalcorp/pp-react-utils';
import { elevationStyles } from '@paypalcorp/pp-react-elevation';
const cardXxsWidth = '6.6875rem';
const cardXxsHeight = '11rem';
const cardXsWidth = '10rem';
const cardXsHeight = '5rem';
const cardXsLongWidth = '20.75rem';
const cardXsLongHeight = '5rem';
const noBorder = {
  border: 'none'
};
export const base = style({
  padding: tokens.space[300],
  position: 'relative',
  textAlign: 'initial',
  backgroundColor: tokens.color.background.surface,
  borderRadius: tokens.border.radius.lg,
  appearance: 'none',
  ':focus': focusStyles.focusInlineElementStyles
}, 'card_base');
export const level1 = style(noBorder, 'card_level1');
export const level3 = style(noBorder, 'card_level3');
export const clickable = style({
  cursor: 'pointer',
  width: '100%',
  appearance: 'none',
  ':hover': elevationStyles.level1Styles,
  ':active': {
    boxShadow: 'none'
  }
}, 'card_clickable');
export const header = style({
  marginBottom: tokens.space[300],
  display: 'table'
}, 'card_header');
export const title = style({
  width: '100%',
  display: 'table-cell',
  margin: 'initial',
  padding: `${tokens.space[50]} 0`,
  textTransform: 'none',
  verticalAlign: 'middle'
}, 'card_title');

// check with design on these values
export const content = style({
  marginTop: '0.9375rem',
  marginBottom: '0.9375rem'
}, 'card_content');

// footer styles
export const footer = style({
  marginTop: tokens.space[300]
}, 'card_footer');
globalStyle(`${footer} button, a`, {
  margin: 'initial'
});
globalStyle(`${footer} button:not(:last-child), ${footer} a:not(:last-child)`, {
  marginInlineEnd: tokens.space[300]
});

// sizes
export const sizeXxs = style({
  minWidth: cardXxsWidth,
  minHeight: cardXxsHeight
}, 'size_xxs');
export const sizeXs = style({
  minWidth: cardXsWidth,
  minHeight: cardXsHeight
}, 'size_xs');
export const sizeXsLong = style({
  minWidth: cardXsLongWidth,
  minHeight: cardXsLongHeight,
  borderRadius: tokens.border.radius.lg
}, 'size_xs-long');
__vanilla_filescope__.endFileScope();
